import {
  MailSequenceReferenceDateType,
  PatientNameDataFragment,
} from '../../../generated/graphql';
import { SavedActivityInputPreview } from '../../lib/followUp';

/** Optional prefill when navigating from the mail composer. */
export type ScheduleMailLocationState = {
  programIds?: string[];
  recipientPatients?: PatientNameDataFragment[];
  activities?: SavedActivityInputPreview[];
  subject?: string;
  providerNote?: string;
  providerVoiceNoteId?: string | null;
  isIntake?: boolean;
  returnTo?: string;
  referenceDateType?: MailSequenceReferenceDateType;
  /** YYYY-MM-DD when using a custom reference date. */
  customAnchorDate?: string;
};

export const SCHEDULE_MAIL_PATH = '/schedule-mail';

const SCHEDULE_MAIL_STATE_KEYS: Array<keyof ScheduleMailLocationState> = [
  'programIds',
  'recipientPatients',
  'activities',
  'subject',
  'providerNote',
  'providerVoiceNoteId',
  'isIntake',
  'returnTo',
  'referenceDateType',
  'customAnchorDate',
];

export const isScheduleMailLocationState = (
  value: unknown,
): value is ScheduleMailLocationState => {
  if (!value || typeof value !== 'object') return false;
  return SCHEDULE_MAIL_STATE_KEYS.some((key) => key in value);
};
